import React, { type ButtonHTMLAttributes, type FC } from 'react';

import { ArrowDownUpIcon } from 'lucide-react';

import { useSwapContext } from '@/pages/Swap/context/SwapContext';
import { cn } from '@/utils';
import { checkSupportedPair } from '@/utils/checkSupportedPair';

type Props = {
  onToggle?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const SwapInputsToggleButton: FC<Props & ButtonHTMLAttributes<HTMLButtonElement>> = ({
  onToggle,
  className,
  ...rest
}) => {
  const { tokenFrom, tokenTo, setTokenFrom, setTokenTo } = useSwapContext();

  const handleTokenSwitch = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setTokenFrom(tokenTo);
    setTokenTo(tokenFrom);

    if (typeof onToggle === 'function') {
      onToggle(e);
    }
  };

  // This prevents the user to switch to a combination of tokens that is not supported
  const isSwitchedPairSupported = checkSupportedPair(tokenTo, tokenFrom);

  return (
    <button
      disabled={!isSwitchedPairSupported}
      className={cn(
        `border-foreground bg-primary-purple text-foreground hover:bg-primary-purple/60 disabled:hover:border-foreground
        flex size-10 cursor-pointer items-center justify-center rounded-full border-[6px] p-1 shadow-none transition
        duration-300 ease-in-out hover:rotate-180 hover:border-purple-400 disabled:cursor-not-allowed
        disabled:bg-slate-600/80 disabled:opacity-100 disabled:hover:rotate-0 disabled:hover:bg-slate-600/70`,
        className
      )}
      onClick={handleTokenSwitch}
      {...rest}
    >
      <ArrowDownUpIcon />
    </button>
  );
};

export default SwapInputsToggleButton;
